
<template>
      <router-view></router-view>
</template>

<script>
  export default { 
    name: "App"
  }
</script>

<style>
#app, .login
{
  margin-top: 30px;
}

</style>
